<script setup lang="ts">
defineSlots<{
  default: () => unknown
}>();
</script>

<template>
  <aside class="lg:hidden fixed bottom-0 inset-x-0 flex items-center justify-between bg-white drop-shadow-[0_-2px_4px_rgba(0,0,0,0.2)] px-l py-xs z-10">
    <slot />
  </aside>
</template>
